'use client';
import { isString } from '@s7/utils';

/**
 * Создаёт функцию-валидатор для идентификаторов DOM-элементов.
 *
 * @note
 * Строка валидируется на непустое значение. Убедитесь, что строка не содержит только пробельные символы.
 *
 * @param uid - уникальный идентификатор, используемый в качестве префикса.
 * @param errorMessage - сообщение об ошибке, которая будет выброшено в случае некорректного значения.
 * @returns Функция-валидатор, принимающая строковое значение и возвращающая строку с добавленным префиксом.
 *
 * @primaryExample
 * const validateDomId = createIdGuard('component', 'Неверный идентификатор элемента');
 * validateDomId('header'); // 'component-header'
 * validateDomId(); // Ошибка: Неверный идентификатор элемента
 */ var createIdGuard = function(uid, errorMessage) {
    return function(value) {
        if (!isString(value) || value.trim().length === 0) {
            throw new Error(errorMessage);
        }
        return uid + "-" + value;
    };
};

export { createIdGuard };
